import React, {
  useState,
  useEffect,
}                           from 'react';
import { toast }            from 'react-toastify';
import PropTypes            from 'prop-types';

import { useTranslation }   from 'react-i18next';
import Input                from '@material-ui/core/Input';
import IconButton           from '@material-ui/core/IconButton';
import SearchIcon           from '@material-ui/icons/Search';
import CloseIcon            from '@material-ui/icons/Close';
import InputAdornment       from '@material-ui/core/InputAdornment';
import { historyPropType }  from '~/config/routerPropTypes';
import useStyles            from './styles';

function SearchBar({ onSearch, history, eraseQS}){
  const { qs, per_page } = history.location.route.getParams();
  const { t } = useTranslation();
  const [ value, setValue] = useState(qs ? qs : '');
  const classes = useStyles();

  const handleChange = event => setValue(event.target.value);

  useEffect(() => setValue(qs), [qs]);

  const handleQs = () => {
    if(value && value.trim().length >= 3)
      return onSearch(value, per_page);

    if(qs)
      return eraseQS(per_page);

      return toast.error(t('search-toast-error'));
  };

  const handleKeyPress = (e) =>{
    if(e.key === 'Enter'){
      handleQs();
    }
  };

  return(
    <Input
      autoFocus
      placeholder={t('search-placeholder')}
      value={value || ''}
      inputProps={{ 'aria-label': 'Busca' }}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      startAdornment={
        <InputAdornment position="start">
          {(value || qs || '') &&
          <IconButton
            className={classes.leftIconButton}
            onClick={() => eraseQS(per_page)}
          >
            <CloseIcon className={classes.closeIcon}/>
          </IconButton>}
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={handleQs}>
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );
}

SearchBar.propTypes={
  onSearch: PropTypes.func.isRequired,
  queryString: PropTypes.string,
  history: historyPropType,
};

export default SearchBar;
